import React, { FC, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import FhirLoader from '../../../components/FhirLoader'
import { Link } from 'react-router-dom'
import useProviders from '../../../hooks/admin/useProviders'
import isAuthenticated from '../../../routes/PrivateRoute'
import { formatDateInTimeZone } from '../../../utils/helpers'
import PageTitle from '../../../components/PageTitle'

const Providers: FC = () => {
  const [searchName, setSearchName] = useState('')
  const [searchId, setSearchId] = useState('')

  const { isLoading, data, refetch, isSuccess } = useProviders(searchName, searchId)

  const handleProviderSearch = (e: any) => {
    e.preventDefault()
    refetch()
  }

  return (
    <Container
      className='pt-3 pb-3'
    >
      <PageTitle displayName="Provider Directory" />
      <h1 className='h2'>Provider Directory</h1>
      <Form noValidate onSubmit={handleProviderSearch} className='d-flex'>
        <Form.Group>
          <Form.Label className='me-4'>Find a Provider</Form.Label>
          <Form.Control
            className='me-4'
            type='text'
            name='searchName'
            placeholder="Type Provider Name"
            value={searchName}
            onChange={(e: any) => setSearchName(e.target.value)}
          />
          <Form.Control
            className='me-4'
            type='text'
            name='searchId'
            placeholder="Type Provider ID"
            value={searchId}
            onChange={(e: any) => setSearchId(e.target.value)}
          />
        </Form.Group>
        <Button variant="primary" className="btn-primary-custom" type="submit">
          Search
        </Button>
      </Form>
     {isLoading ? (
        <div className='d-flex flex-column align-items-center p-2' style={{ backgroundColor: '#e3e3e3' }}>
          <FhirLoader message="Loading Providers..." />
        </div>
      ) : (
      <Table hover size='sm' className='mt-3'>
        <thead>
          <tr>
            <th scope="col" >ID (NPI)</th>
            <th scope="col" >Provider Name</th>
            <th scope="col" >Resource Type</th>
            <th scope="col" >Last Updated</th>
            <th scope="col" >Fhir Data</th>
          </tr>
        </thead>
        <tbody>
          {
            isSuccess && data?.length > 0 ? (
              <>
                {
                  data.map((provider: any) => (
                    <tr key={provider.identifier[0].value}>
                      <td>{provider.id}</td>
                      <td>{`${provider.name[0].given[0] || ''} ${provider.name[0].family || ''}`}</td>
                      <td>{provider.resourceType}</td>
                      <td>{formatDateInTimeZone(provider.meta.lastUpdated, 'MM/dd/yyyy', 'UTC')}</td>
                      <td><Link to={`/provider/${provider.id}?name=${searchName}&id=${searchId}`}>View Data</Link></td>
                    </tr>
                  ))
                }
              </>
            ) : (
              <>
                {data?.length === 0 &&
                  <tr>
                    <td scope="row" colSpan={5} className='text-center' style={{ backgroundColor: '#e3e3e3' }}>
                      <span>Provider Not found!</span>
                    </td>
                  </tr>
                }
              </>
            )
          }
        </tbody>
      </Table>
      )}
    </Container>
  )
}

export default isAuthenticated(Providers)